import { render, staticRenderFns } from "./FolderBreadcrumbs.vue?vue&type=template&id=11e30387"
import script from "./FolderBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./FolderBreadcrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports